import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69016a5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "house-item" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_HouseItem = _resolveComponent("HouseItem", true)!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
    return (_openBlock(), _createElementBlock("div", {
      class: _normalizeClass({
      'uf-staff-selector__item--active': _ctx.checkedHouse.id == item.id
    }),
      key: item.id,
      onClick: ($event: any) => (_ctx.onClick(item)),
      style: {"padding-left":"20px"}
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, _toDisplayString(item.place), 1),
        (item.lists.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: ($event: any) => (item.flag = !item.flag)
            }, [
              _createVNode(_component_van_icon, {
                name: item.flag ? 'arrow-down' : 'arrow',
                size: "18",
                color: "#999"
              }, null, 8, ["name"])
            ], 8, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      (item.flag)
        ? (_openBlock(), _createBlock(_component_HouseItem, {
            key: 0,
            list: item.lists,
            checked: _ctx.checkedHouse,
            onChange: _ctx.updateChecked
          }, null, 8, ["list", "checked", "onChange"]))
        : _createCommentVNode("", true)
    ], 10, _hoisted_1))
  }), 128))
}